import React, { Component, useContext, useState } from "react";
import Axios from "axios";

import {
  Drawer,
  Form,
  Button,
  Col,
  Row,
  Input,
  notification,
  message,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { BaseContext } from "../BaseContext";
import { useForm } from "antd/lib/form/Form";

const CreateAccount = () => {
  const [myForm] = useForm();
  const { setToken, setUser, setEmail } = useContext(BaseContext);

  const [visibleDrawer, setVisibleDrawer] = useState(false);


  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: "Create Account Success",
      description:
        "Account already registered, now you unlock the full features of this web. Open sidebar menu to start exploring :)",
    });
  };

  const onFinish = (values) => {

    const { name, password, email } = values;
    if (name) {
      Axios.post("https://backendexample.sanbersy.com/api/register", {
        name: name,
        password: password,
        email: email,
      })
        .then((response) => {
          setToken(response.data.token);
          setUser(response.data.user.name);
          setEmail(response.data.user.email);
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("user", response.data.user.name);
          localStorage.setItem("email", response.data.email);

          openNotificationWithIcon("success");
        })
        .catch((err) => {
          message.error(
            `Registration failed, please use other email to register!`
          );
        });
    }
  };

  const showDrawer = () => {
    setVisibleDrawer(true);
  };

  const onClose = () => {
    setVisibleDrawer(false);
  };

  return (
    <>
      <span style={{ cursor: "pointer" }} onClick={showDrawer}>
        <PlusOutlined /> Sign Up
      </span>
      <Drawer
        title="Create a new account"
        width={720}
        onClose={onClose}
        visible={visibleDrawer}
        bodyStyle={{ paddingBottom: 80 }}
        footer={
          <div
            style={{
              textAlign: "right",
            }}
          >
            <Button onClick={onClose} style={{}}>
              Cancel
            </Button>
            <Button type="primary" onClick={() => { myForm.submit() }}>
              Sign Up
            </Button>
          </div>
        }
      >


        <Form
          layout="vertical"
          hideRequiredMark
          name="formRegister"
          onFinish={onFinish}
          form={myForm}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="Name"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input required placeholder="Please enter user name" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  {
                    type: "email",
                    required: true,
                  },
                ]}
              >
                <Input placeholder="Please enter your email" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Password"
                name="password"
                rules={[{ required: true, min: 6 }]}
              >
                <Input.Password />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </>
  );
};

export default CreateAccount;
